var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsString } from 'class-validator';
import { SteuerberaterTokenResponseDto } from './steuerberater-token.response.dto.js';
/**
 * Response of `POST /steuerberater-share-link/:officeLocationId`. The signed
 * `tokenString` is returned ONCE at mint time — the client embeds it in the
 * copy-link UI and we never echo it again from any other endpoint. A clinic
 * admin who closes the modal without copying must mint a new link.
 */
export class MintSteuerberaterTokenResponseDto {
    token;
    tokenString;
}
__decorate([
    Expose(),
    Type(() => SteuerberaterTokenResponseDto),
    __metadata("design:type", SteuerberaterTokenResponseDto)
], MintSteuerberaterTokenResponseDto.prototype, "token", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], MintSteuerberaterTokenResponseDto.prototype, "tokenString", void 0);
//# sourceMappingURL=mint-steuerberater-token.response.dto.js.map